// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout_layout__EltJt","dashboardContent":"DashboardLayout_dashboardContent__sFwVT"};